import { __decorate, __metadata } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { userstore, lccstore, rcslocationChangeProcess } from 'lcc-state';
import css from '../css/backview.m.css';
let Backview = class Backview extends I18nThemed {
    showButton;
    constructor() {
        super();
        this.showButton = true;
    }
    get_nls() {
        const { get, path } = lccstore;
        const dynls = get(path('dynls'));
        const bundle = dynls && dynls.get('settings');
        if (!bundle) {
            return { isPlaceholder: true, format: () => '', messages: {} };
        }
        return this.localizeBundle(bundle);
    }
    selected(location, overrideurl) {
        const { baseurl } = this.properties;
        if (!location) {
            return;
        }
        let oneLevelUp = location.split('/').slice(0, -1).join('/');
        if (oneLevelUp === baseurl || oneLevelUp.length < baseurl.length) {
            oneLevelUp = baseurl;
        }
        if (overrideurl) {
            oneLevelUp = overrideurl;
        }
        rcslocationChangeProcess(userstore)({
            baseurl: `${baseurl}`,
            location: `${oneLevelUp}`
        });
    }
    render() {
        const { get, path } = userstore;
        const rcslocation = get(path('rcslocation'));
        const { baseurl, overrideurl } = this.properties;
        const location = rcslocation[baseurl];
        this.showButton = location !== baseurl;
        const { messages: { back_title = '[settings] back_title' } } = this.get_nls();
        return this.showButton
            ? v('div', {
                tabIndex: 0,
                title: back_title,
                role: 'button',
                'aria-label': back_title || 'Go Back',
                classes: [this.theme(css.root)],
                onclick: (event) => {
                    event.stopImmediatePropagation();
                    this.selected(location, overrideurl);
                }
            }, [v('i', { classes: ['fa', 'fa-lg', 'fa-angle-double-left'] })])
            : null;
    }
};
Backview = __decorate([
    theme(css),
    __metadata("design:paramtypes", [])
], Backview);
export { Backview };
